import type { Column, Trade } from '@talos/kyoko';

export const DEFAULT_TRADE_COLUMNS: (keyof Trade | Partial<Column>)[] = [
  'TransactTime',
  'Side',
  'Symbol',
  'Quantity',
  'Price',
  'Fee',
  {
    field: 'PriceAllIn',
    title: 'Filled Price All-In',
    type: 'price',
    sortable: true,
    params: { assetField: 'Symbol' },
  },
  'Amount',
  'MarketAccount',
  { field: 'AggressorSide', type: 'side', sortable: true },
  'SubAccount',
  'TradeID',
  'TradeStatus',
  { field: 'OrderID', type: 'id', sortable: true },
  { field: 'User', type: 'user', sortable: true },
  { field: 'EID', type: 'text', initialHide: true },
  { field: 'Comments', type: 'text', initialHide: true },
  { field: 'Group', type: 'text', sortable: true, initialHide: true },
  { field: 'Market', type: 'market', sortable: true, initialHide: true },
  { field: 'MarketTradeID', title: 'Market Trade ID', type: 'text', initialHide: true },
  { field: 'MarketOrderID', title: 'Market Order ID', type: 'text', initialHide: true },
  { field: 'ParentTradeID', title: 'Parent Trade ID', type: 'text', initialHide: true },
  { field: 'QuoteID', type: 'id', sortable: true, initialHide: true },
  { field: 'TradeAction', type: 'text', initialHide: true },
  { field: 'RFQID', type: 'id', initialHide: true },
  { field: 'Timestamp', type: 'date', sortable: true, initialHide: true, params: { milliseconds: true } },
  { field: 'TradeSource', type: 'text', initialHide: true },
];
